import {mutation, query} from "@/graphql/client";
import {ChatContext, HumanRequest, HumanRequestStatus} from "@/graphql/generated/graphql";
import {graphql} from "@/graphql/generated";


export async function fetchHumanRequests(): Promise<Array<HumanRequest>> {
    const result = await query(
        graphql(`query getHumanRequest {
            humanRequests {
                topic
                question
                additionalDescription
                status
                response
            }
        }`)
    );

    return result.data?.humanRequests || [];
}

export async function fetchHumanRequestSuggestions(chatContext: ChatContext): Promise<HumanRequest|undefined>
{
    const result = await query(
        graphql(`query GetHumanRequestSuggestions(
            $chatContext: ChatContextInput!,
        ) {
            humanRequestSuggestions(
                chatContext: $chatContext,
            ) {
                topic
                question
                additionalDescription
            }
        }`),
        {
            chatContext: chatContext
        }
    );
    return result.data?.humanRequestSuggestions;
}


export async function fetchHumanRequest(humanRequestId: number): Promise<HumanRequest|undefined> {
        const result = await query(
            graphql(`query FetchHumanRequest(
                $humanRequestId: Int!,
            ) {
                humanRequest(
                    humanRequestId: $humanRequestId,
                ) {
                    id
                    topic
                    question
                    additionalDescription
                    status
                    response
                }
            }`),
            {
                humanRequestId: humanRequestId
            }
        );
    return result.data?.humanRequest;
}


export async function addHumanRequest(request: HumanRequest) {

    const MUTATION = graphql(`
        mutation AddHumanRequest(
            $topic: String!,
            $question: String!,
            $additionalDescription: String!,
            $chatContext: ChatContextInput!,
        ) {
            addHumanRequest(
                topic: $topic,
                question: $question,
                additionalDescription: $additionalDescription,
                chatContext: $chatContext
            ) {
                topic
                question
                additionalDescription
                chatContext {
                    runId
                }
                status
                response
            }
        }`)

    const result = await mutation(
        MUTATION, {
            topic: request.topic,
            question: request.question,
            additionalDescription: request.additionalDescription,
            chatContext: request.chatContext
        }
    )

    const success = result?.data?.addHumanRequest

    if (!success) {
        throw new Error("error while storing absence")
    }

    return success
}

export async function setHumanRequestStatus(humanRequestId: number, status: HumanRequestStatus ) {

    const MUTATION = graphql(`
        mutation SetHumanRequestStatus(
            $humanRequestId: Int!,
            $status: String!,
        ) {
            setHumanRequestStatus(
                humanRequestId: $humanRequestId,
                statusString: $status,
            ) 
        }`)

    const result = await mutation(
        MUTATION, {
            humanRequestId: humanRequestId,
            status: status,
        }
    )

    const success = result?.data

    if (!success) {
        throw new Error("error while storing absence")
    }

    return success
}


